import React from 'react'
import Subheader from '../../component/Subheader'
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { useNavigate } from "react-router-dom";

export default function TermsConditions() {

  const subheadData = {
    heading: 'Terms of use & Privacy Policy',
    breadcrumb: [
      {
        slug: "",
        name: "Terms of Use",
      },
    ]
  }
  const navigate = useNavigate();


  return (
    <>
      <Subheader subheadData={subheadData} />

      <section className="termscondition-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="term-condition-area">
                <Tab.Container defaultActiveKey="first">
                  <Row>
                    <Col md={4} lg={3}>
                      <Nav className="flex-column quicklinks-nav">
                        <h2 className="heading">Quick Links</h2>
                        <Nav.Item>
                          <Nav.Link eventKey="first">Terms and Conditions</Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                          <Nav.Link eventKey="second">Privacy Policy</Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                          <Nav.Link eventKey="third">Refund & Cancellation Policy</Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                          <Nav.Link eventKey="four" onClick={() => navigate("/faqs")}>FAQ’s</Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                          <Nav.Link eventKey="five">Child Policy</Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                          <Nav.Link eventKey="six">Pets Policy</Nav.Link>
                        </Nav.Item>

                      </Nav>
                    </Col>

                    <Col md={8} lg={9}>
                      <Tab.Content className="quicklinks-content">
                        <Tab.Pane eventKey="first">
                          <div className="termscondition-text">
                            <span>TERMS & CONDITIONS</span>
                            <h3 className="heading">Terms and Conditions</h3>
                            <p>
                              The services of this Site are available only to individuals who can form legally binding contracts under applicable law, and thus, are not available to minors. By using this Site, You represent that you are of sufficient legal age to use this Site and to create binding legal obligations for any liability you may incur as a result of the use of this Site. You also warrant that you are legally authorized to make the travel reservations and/or purchases for either yourself or for another person for whom You are authorized to act.
                            </p>
                            <p>

                              You may only use this Site to make legitimate reservations or purchases and shall not use this Site for any other purposes, including without limitation, to make any speculative, false or fraudulent reservations, or any reservation in anticipation of demand.</p>
                            <p>

                              This Site is to be used by you for Your personal use only. Commercial uses of this Site are strictly prohibited unless prior written consent has been granted. You agree that You will not use this Site for chain letters, junkmail, 'spamming', solicitations (commercial or non-commercial) or bulk communications of any kind including but not limited to distribution lists to any person who has not given specific permission to be included in such a list. In addition, You agree not to create a hypertext link from any web site controlled by You or otherwise, to this Site without the express written permission.</p>
                            <p>

                              By accessing using, viewing, transmitting, caching or storing this site or any of its services, functions or contents, you shall be deemed to have agreed to each and all the terms, conditions, and notices in this site ('agreement') without modification. If you do not agree, please cease use of the site and leave the site immediately
                            </p>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="second">
                          <div className="termscondition-text">
                            <span>Privacy Policy</span>
                            <h4 className="heading">Privacy Policy</h4>
                            <p>Resort De Coração Hotels collects information about our guests and visitors to our web sites so that we can provide an experience that is responsive to our guests needs. We endeavour to collect information only with your knowledge and with your permission if necessary. The types of personally identifiable information that we collect may include your name, home, work and e-mail addresses, telephone and fax numbers, credit card information, date of birth, gender, and lifestyle information such as room preferences, leisure activities, names and ages of children, and other information necessary to fulfil special requests (e.g., health conditions that require special room accommodations).</p>
                            <p>Resort De Coração Hotels is fully committed to providing you with information about the collection and use of personally identifiable information furnished by, or collected from, visitors while using our web sites, products and services. It is our practice not to ask you for information unless we need it or intend to use it.</p>
                            <p>To ensure that your personally identifiable information is accurate and up to date, we encourage you to regularly review and update your information as appropriate (e.g., in the event your home or e- mail address changes, or you wish to add an additional method for us to communicate with you).</p>
                            <p>Resort De Coração Hotels recognizes the importance of information security, and is constantly reviewing and enhancing our technical, physical, and logical security rules and procedures to help protect your personally identifiable information against loss, misuse, and alteration while under our control. Although 'guaranteed security' does not exist either on or off the Internet, we safeguard your information using both procedural and technical safeguards, including password controls, 'firewalls” etc.</p>
                            <p>Any Musical Instruments that could disturb other guests' peaceful experience, such as personal speakers, woofers, or any musical instrument playing loud music are prohibited on the property.</p>
                            <p>Proper swimwear is mandatory. The aim is to maintain cleanliness on the property.</p>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="third">
                          <div className="termscondition-text">
                            <span>Refund & Cancellation Policy</span>
                            <h4 className="heading">Refund & Cancellation Policy</h4>
                            <p>If the booking is cancelled within 7 days prior of check in date – 100% retention charges will apply. If cancelled prior to 7 days from the check in date - NIL charges apply.</p>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="five">
                          <div className="termscondition-text">
                            <span>Child Policy</span>
                            <h4 className="heading">Child Policy</h4>
                            <p>Child below 5 years will be complimentary without an extra Bed and child above 5 years will be considered as extra person in the room inclusive of extra Mattress.</p>
                          </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="six">
                          <div className="termscondition-text">
                            <span>Pets Policy</span>
                            <h4 className="heading">Pets Policy</h4>
                            <p>In order to ensure your and your pet’s comfort, we kindly ask you to read our pet policy:</p>
                            <ul>
                              <li>Pet is allowed in only one category of Rooms that is Luxury cottage (Ground floor) and not any other category of rooms.</li>
                              <li>Pet must be fully trained and appropriately restrained by the guest at all times. Pet must be kept on a leash when in the resort or on resort property unless in the guest’s room.</li>
                              <li>Guest to confirm number and breed of pets upon booking. Limitations may apply. For a comfortable stay for you and your pet, a maximum of 2 pets is allowed per room. Owners can bring pets into their resort room via the side entrance of the Resort.</li>
                              <li>Verification that vaccinations are complete and up-to-date is required.</li>
                              <li>Pet left unattended in the guest room when the guest leaves the hotel premises must be secured in a proper pet crate or carrier (By Own) OR free but for any damages guest is responsible. Need to settle the bill at the time of check-out.</li>
                              <li>Pet must be on a controlled leash at all times when not inside of the guest room.</li>
                              <li>Pets must not be walked through the lobby, restaurant, pool, pool deck, indoor play areas and spa of the Resort.</li>
                              <li>Pet must only be walked on the designated pet area(s) of the resort grounds.</li>
                              <li>Guest is responsible for cleaning up after the pet on resort grounds and properly disposing of the waste in the outside dumpster or otherwise designated.</li>
                              <li>Pets are not allowed in the main building of the hotel. Pets may be left unattended in your room for a short time if the Guest is going out of the resort then the front office/reception needs to inform in advance.</li>
                              <li>Pet Food & Utensils are of guests, cooked food is available at the resort on a chargeable basis and can be ordered from room service.</li>
                              <li>Any disturbances such as barking must be curtailed to ensure other guests are not inconvenienced.</li>
                              <li>Guests are responsible for all property damage (including and not limited to accommodation rooms) and/or personal injuries resulting from their pets. The hotel reserves the right to charge the guest’s account commensurate to the cost of any damages.</li>
                              <li>Pet stay terms and conditions are subject to change without prior notice.</li>
                              <li>A non-refundable pet fee of Rs. 2000 + GST is charged to guest account at the time of booking.</li>
                              <li>Housekeeping and Maintenance Service: Guest agrees to make his room available for housekeeping and/or maintenance needs and will arrange to have his/her pet out of the room to accommodate this service.</li>
                              <li>Pet-Friendly areas – pets are allowed only in the following areas. Guest room, lawn & garden areas. Pets are not allowed in public areas where F&B is served or consumed.</li>
                              <li>Pet Control / Containment in public areas pets must be leashed, caged, or firmly held when they are in all common areas of the hotel.</li>
                              <li>Pet must weigh less than 35kg.</li>

                            </ul>
                          </div>
                        </Tab.Pane>

                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
